<template>
    <div class="smsTemplateList">
        <div class="query">
            <div>
                <el-input
                    style="width: 150px;"
                    placeholder="模板名称"
                    clearable
                    size="mini"
                    @keyup.enter.native="findTemplatePageList"
                    v-model="queryParam.templateName"
                    prefix-icon="el-icon-chat-line-square"
                ></el-input>
                <el-button
                    type="primary"
                    circle
                    plain
                    size="mini"
                    @click="findTemplatePageList"
                    icon="el-icon-search"
                ></el-button>
            </div>
        </div>
        <el-table
            :data="tableData"
            style="width: 100%"
        >
            <el-table-column prop="templateName" label="模版名称"></el-table-column>
            <el-table-column
                label="操作"
                width="50">
                <template slot-scope="scope">
                    <el-link
                    @click.native.prevent="checkRow(scope.$index, tableData)"
                    type="primary"
                    :underline="false">
                    填入
                    </el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <el-col :span="24" align="right">
                <el-pagination
                    small
                    class="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="paginations.page_index"
                    :page-size="paginations.page_size"
                    :layout="paginations.layout"
                    :total="paginations.total"
                ></el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { findTemplatePageList } from "@/api/index";

export default {
    props: {
    },
    data() {
        return {
            queryParam: {
                templateName: ""
            },
            tableData: [],
            paginations: {
                page_index: 1, //当前位于哪页
                total: 0, //总数
                page_size: 4, //每页显示多少条
                layout: "total, prev, pager, next"
            }
        };
    },
    methods: {
        findTemplatePageList() {
            let that = this;
            findTemplatePageList({
                templateName: this.queryParam.templateName,
                templateStatus: 1,
                pageIndex: this.paginations.page_index,
                size: this.paginations.page_size,
            }).then((res) => {
                if (res.success == true) {
                that.tableData = res.result.list;
                this.paginations.total = res.result.total;
                } else {
                this.$notify.error({
                    title: "错误",
                    message: res.message,
                });
                }
            });
        },
        handleSizeChange(val) {
            this.paginations.page_size = val;
            this.findMemberPageList();
        },
        handleCurrentChange(val) {
            this.paginations.page_index = val;
            this.findMemberPageList();
        },
        checkRow(index, rows) {
            this.$emit("selectTemplate", rows[index])
        }
    },
    created() {
        this.findTemplatePageList();
    }
};
</script>

<style lang="scss">
.smsTemplateList {
    margin: 0px;
}
</style>